// encryption-utils.js
import CryptoJS from "crypto-js";

const SECRET_KEY = "a2f5c1b8e515e9fbc41f47c63494d3fdb3e61408f471fd7c6e6e218e18eaa9e4";

export function encryptForURL(dataObj) {
  const stringified = JSON.stringify(dataObj);
  const encrypted = CryptoJS.AES.encrypt(stringified, SECRET_KEY).toString();
  return encodeURIComponent(encrypted);
}

export function decryptFromURL(encryptedUrlString) {
  const decrypted = CryptoJS.AES.decrypt(decodeURIComponent(encryptedUrlString), SECRET_KEY);
  const plainText = decrypted.toString(CryptoJS.enc.Utf8);
  return JSON.parse(plainText);
}
